import React, { useCallback } from 'react'
import { Link } from 'gatsby'
import * as style from './index.module.css'
import {
  ALL_ROUTE,
  HEADER_ROUTES,
  CONPANY_NAME,
  ENTRY_LINK,
  SOZO_WHITE_BOX_ROUTES,
  PORTFOLIO_ROUTES,
} from '@/utils/const'
import {
  NavigateText,
  CtaButton,
  ATagText,
} from '@/components/atoms/entrypoint'
import { StaticImage } from 'gatsby-plugin-image'
import { fireEvent } from '@/utils/activityLog'
import { useGetCurrentPath } from '@/utils/hooks/useGetCurrentPath'
import { navigate } from 'gatsby'

/**
 * @file PC・TABで使用するHeader
 */
export const PcTabHeader = (): React.JSX.Element => {
  const { currentPath } = useGetCurrentPath()

  const onClickRoot = useCallback((): void => {
    fireEvent({
      event: 'clickHeaderMenu',
      parameters: {
        current_path: currentPath,
        next_path: ALL_ROUTE[0].route,
      },
    })
  }, [currentPath])

  const onClickEntry = useCallback((): void => {
    fireEvent({
      event: 'clickHeaderEntryButton',
      parameters: {
        current_path: currentPath,
      },
    })
    navigate(ENTRY_LINK)
  }, [currentPath])

  const onClickHeaderMenu = useCallback(
    (route: string): void => {
      fireEvent({
        event: 'clickHeaderMenu',
        parameters: {
          current_path: currentPath,
          next_path: route,
        },
      })
    },
    [currentPath],
  )
  return (
    <header aria-label="ヘッダー" className={style.root}>
      <div className={style.logoArea}>
        <StaticImage
          src="../../../../images/logo.webp"
          loading="eager"
          width={42}
          height={42}
          formats={['auto', 'webp', 'avif']}
          alt="logo"
        />
        <Link
          to={ALL_ROUTE[0].route}
          aria-label="会社名"
          className={style.companyName}
          onClick={onClickRoot}
        >
          {CONPANY_NAME}
        </Link>
      </div>
      <div className={style.navArea}>
        <nav aria-label="ヘッダーナビゲーション" className={style.navList}>
          <ATagText
            text={SOZO_WHITE_BOX_ROUTES.text}
            textColor="black"
            to={SOZO_WHITE_BOX_ROUTES.link}
          />
          {HEADER_ROUTES.map((list, index) => (
            <NavigateText
              key={index}
              textColor="black"
              to={list.route}
              text={list.text}
              onClick={() => onClickHeaderMenu(list.route)}
            />
          ))}
        </nav>
        <CtaButton type="whiteTextEntry" onClick={onClickEntry} />
      </div>
    </header>
  )
}
